<script>
export default {
  props: {
    type: {
      type: String,
      default: 'text',
    },
    name: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    base: {
      type: Boolean,
      required: false,
      default: false,
    },
    full: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxlength: {
      type: Number,
      required: false,
      default: 0,
    },
    onlyNumbers: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    listeners () {
      return {
        ...this.$listeners,
        input: event => this.$emit('input', event.target.value),
      }
    },
    maxlengthAttribute () {
      const attributes = {}
      if (this.maxlength > 0) {
        attributes.maxlength = this.maxlength
      }
      return attributes
    }
  },
  methods: {
    onlyNumber ($event) {
      if (!this.onlyNumbers) return;
      let keyCode = $event.keyCode || $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        $event.preventDefault();
      }
    }
  }
}
</script>

<template>
  <input
    :type="type"
    :value="value"
    :name="name"
    :placeholder="placeholder"
    :class="[{ [$style.inputBase]: base },{ [$style.inputFull]: full }, $style.input]"
    v-bind="maxlengthAttribute"
    :disabled="disabled"
    v-on="listeners"
    @keypress="onlyNumber"
  >
</template>

<style lang="scss" module scoped>
@import '@design';

.input {
  @extend %typography-small;

  padding: $size-input-padding-vertical $size-input-padding-horizontal;
  margin-bottom: $size-grid-padding;
  border: $size-input-border solid $divider-gray;
  border-radius: $size-input-border-radius;
  outline: none;

  &Base {
    width: 90%;
    text-align: left;
    background-color: white;
  }

  &Full {
    width: 90%;
    text-align: left;
  }
}

input::-webkit-input-placeholder {
  margin-bottom: 0;
  color: $blue-gray;
}

input {
  &:focus {
    outline: none;
  }
}
</style>
